/* istanbul ignore file */
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { RubricDescriptionType } from './RubricDescriptionType';
const BaseRubricRowParser = /* #__PURE__ */ parsers.object([
    ['originalId', codecNumber, 'original_id'],
    ['header', codecString],
    ['description', /* #__PURE__ */ parsers.maybeNull(codecString)],
    ['descriptionType', RubricDescriptionType, 'description_type'],
]);
export class BaseRubricRow extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return BaseRubricRowParser.decode(input).map(res => new BaseRubricRow(res));
    }
    static unsafeDecode(input) {
        return BaseRubricRow.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return BaseRubricRowParser.encode(data);
    }
    static schema() {
        return BaseRubricRowParser.schema();
    }
}
